import React, { useRef, ForwardedRef, useImperativeHandle, forwardRef, JSX } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import useConfig from '../../Hooks/useConfig';

export interface GoogleReCaptchaWrapperProps {
  onChange: (token: string | null) => void;
  onErrored?: () => void;
  onExpired?: () => void;
  compact?: boolean;
}

export type GoogleReCaptchaRefType = {
  reset: () => void;
  execute: () => void;
  executeAsync: () => Promise<void>;
};

const GoogleReCaptchaWrapper = forwardRef(
  (props: GoogleReCaptchaWrapperProps, ref?: ForwardedRef<GoogleReCaptchaRefType>): JSX.Element => {
    const config = useConfig();
    const { onChange, onErrored, onExpired, compact } = props;
    const reCaptchaRef = useRef<ReCAPTCHA>(null);

    useImperativeHandle(ref, () => ({
      reset: () => {
        reCaptchaRef.current?.reset();
      },
      execute: () => {
        reCaptchaRef.current?.execute();
      },
      executeAsync: async () => {
        await reCaptchaRef.current?.executeAsync();
      }
    }));

    return config.googleReCaptchaKey ? (
      <ReCAPTCHA
        ref={reCaptchaRef}
        onErrored={onErrored}
        onExpired={onExpired}
        sitekey={config.googleReCaptchaKey}
        onChange={onChange}
        size={compact ? 'compact' : 'normal'}
      />
    ) : (
      <></>
    );
  }
);

export default GoogleReCaptchaWrapper;
